import {useRouter} from '@s-ui/react-router'

import {ROUTES} from '../../../../../config/index.js'

export const useNavigationTransactionBuyerIdentity = () => {
  const {push} = useRouter()

  const navigation = interactionUrl => {
    const {searchParams} = new URL(interactionUrl)
    const tradeId = searchParams.get('tradeId')
    const adId = searchParams.get('adId')

    push(`${ROUTES.TRANSACTION.BUYER_ID}?tradeId=${tradeId}&adId=${adId}`)
  }

  return navigation
}
